<form [formGroup]="thermalExcelUploadForm">
  <div class="modal-body">

    <div class="import-controls mb-3">

      <div class="import-controls__control">
        <label for="inputExcelOptionSelect" class="form-label">Select table to upload to</label>
        <select formControlName="thermalOption" class="form-select" aria-label="Select an Excel type" id="inputExcelOptionSelect">
          <option [ngValue]="null" selected disabled>Please select</option>
          <h6 class="dropdown-header">Dropdown header</h6>
          <option *ngFor="let option of thermalOptions | keyvalue" value="{{option.key}}">{{option.value}}</option>
        </select>
      </div>
    
      <div class="import-controls__control">
        <label class="form-label" for="inputExcelFile">Choose an Excel File</label>
        <input type="file" formControlName="excelFile" name="excelFile" class="form-control" id="inputExcelFile" required
          (change)="handleExcelFileSelect($event)"
          accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel">
      </div>

    </div>
  
  
    <table class="table table-striped">

      <thead>
        <tr>
          <th scope="col" *ngFor="let col of columnHeadersFromExcel">{{col}}</th>
        </tr>
      </thead>
  
      <tbody *ngIf="!!rowsFromExcel; else emptyState">
        <tr *ngFor="let row of rowsFromExcel; index as i">
          <td *ngFor="let value of getObjectValues(row)">{{value}}</td>
        </tr>
      </tbody>
  
      <ng-template #emptyState>
        <tbody>
          <tr class="empty-state-row">
            <td colspan="7" class="empty-state">Please upload an Excel file with thermal data.</td>
          </tr>
        </tbody>
      </ng-template>
      
    </table>  
  </div>
  
  <div class="modal-footer upload-modal-footer">
    <div class="modal-error-message" *ngIf="displayError">
      {{errorMessage}}
    </div>
    <div class="modal-buttons">
      <button type="button" class="btn btn-primary" (click)="uploadExcelObject()">Upload</button>
    </div>
  </div>
</form>

<ngx-spinner bdColor="rgba(0, 0, 0, 0.8)" size="default" color="#fff" type="square-loader" [fullScreen]="false">
  <p class="spinner-loading-text">Uploading...</p>
</ngx-spinner>